document.addEventListener('DOMContentLoaded', function () {
    const zoomContainers = document.querySelectorAll('.container-image');

    zoomContainers.forEach((container) => {
        const img = container.querySelector('img');

        container.addEventListener('click', () => {
            if (container.classList.contains('zoom')) {
                container.classList.remove('zoom');
            } else {
                container.classList.add('zoom');
            }
        });

        container.addEventListener('mousemove', (e) => {
            if (container.classList.contains('zoom')) {
                const rect = container.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;

                img.style.transformOrigin = `${(x / rect.width) * 100}% ${(y / rect.height) * 100}%`;
            }
        });

        container.addEventListener('touchmove', (e) => {
            if (container.classList.contains('zoom')) {
                const touch = e.touches[0];
                const { width, height } = container.getBoundingClientRect();
                const x = touch.clientX - container.offsetLeft;
                const y = touch.clientY - container.offsetTop;

                img.style.transformOrigin = `${(x / width) * 100}% ${(y / height) * 100}%`;
            }
        });
    });
});
